<script>
import {VennHelper} from "../../../helpers/VennHelper";
const VIEW_TYPE_ORGANIC = 'organic';
const VIEW_TYPE_BACKLINKS = 'backlinks';

    export default {
        props: ['domains', 'joins', 'view'],
        data () {
            return {
                d3: null,
                venn: null
            }
        },

        mounted(){

            let d3 = import("d3"),
                venn = import("venn.js"),
                self = this;

            Promise.all([d3, venn]).then(values => {

                self.d3 = values[0];
                self.venn = values[1];

                self.draw();

            });

        },

        methods: {
            draw() {

                let sets = [],
                    domains = [],
                    self = this,
                    key = this.view === VIEW_TYPE_ORGANIC
                        ? 'it50'
                        : this.view === VIEW_TYPE_BACKLINKS
                            ? 'numdomain'
                            : 'adkeyscnt',
                    label = this.view === VIEW_TYPE_ORGANIC
                        ? this.$t("lang.tools.site_compare.organic")
                        : this.$t("lang.tools.site_compare.context");

                sets = VennHelper.buildVennSets(this.domains, this.joins, key);
                this.domains.forEach((d) => {
                    domains[d.id] = d.name;
                });

                let chart = self.venn.VennDiagram().width(400).height(250),
                    div = self.d3.select("#venn");

                div.datum(sets).call(chart);
                // В оригинале venn.js рисует числа по d.size.
                // Нам нужно показать домены вместо чисел, а значения оставить в tooltip.
                div.selectAll("text").each(function (d) {
                    if (!d || !d.sets) {
                        return;
                    }
                    // Подпись — только для одиночного круга, иначе будет каша из длинных строк.
                    if (d.sets.length === 1) {
                        self.d3.select(this).text(domains[d.sets[0]] ?? '');
                    } else {
                        self.d3.select(this).text('');
                    }
                });

                self.d3.select("body").selectAll("div.venntooltip").remove();
                let tooltip = self.d3.select("body").append("div").attr("class", "venntooltip").style("pointer-events", "none");
                div.selectAll("path").style("stroke-opacity", 0).style("stroke", "#fff").style("stroke-width", 3);

                div.selectAll("g")
                    .on("mouseover", function(d, i) {
                        self.venn.sortAreas(div, d);
                        let dnames = [];
                        for (let i = 0; i < d.sets.length; i++)
                            dnames.push(domains[d.sets[i]]);
                        let s = '';
                        if (dnames.length === 1) {
                            s = (
                                self.view === VIEW_TYPE_BACKLINKS
                                ? self.$t("lang.tools.site_compare.links_keys", [dnames[0]])
                                : self.$t("lang.tools.site_compare.site_keys", [dnames[0] + label])
                            )
                        } else if (dnames.length > 1) {
                            s = (
                                self.view === VIEW_TYPE_BACKLINKS
                                ? self.$t("lang.tools.site_compare.links_keys_common", [dnames.join(', ')])
                                : self.$t("lang.tools.site_compare.site_keys_common", [label, dnames.join(', ')])
                            );
                        }

                        tooltip.transition().duration(400).style("opacity", 1);
                        tooltip.text(s + ': ' + ((d.exactSize ?? d.size)));

                        let selection = self.d3.select(this).transition("tooltip").duration(400);

                        selection.select("path")
                            .style("fill-opacity", d.sets.length == 1 ? .4 : .1)
                            .style("stroke-opacity", 1);
                    })

                    .on("mousemove", function() {
                        tooltip
                            .style("position", "fixed")
                            .style("z-index", 1)
                            .style("left", (self.d3.event.pageX) + "px")
                            .style("top", (self.d3.event.pageY - 28) + "px");
                    })

                    .on("click", function(d, i) {
                        let selection = self.d3.select(this).transition("tooltip").duration(400);
                        let attr = selection.node().getAttribute("data-venn-sets");

                        if(attr){
                            attr = attr.split('_');
                            self.$emit('update-select', attr);
                        }
                    })

                    .on("mouseout", function(d, i) {
                        tooltip.transition().duration(400).style("opacity", 0);
                        let selection = self.d3.select(this).transition("tooltip").duration(400);
                        selection.select("path").style("fill-opacity", d.sets.length == 1 ? .25 : .0).style("stroke-opacity", 0);
                    });

            }
        }


    }

</script>

<template>

    <div id="venn"></div>

</template>
